var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomBudget = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.107 7.73C2.132 12.612 2.68 19.847 7.34 24.044l6.939-8.693L6.107 7.73z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.947 3.533h-.051c-3.05 0-5.98 1.247-8.138 3.477l8.19 7.639V3.533z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.564 15.299-7.47 9.36c5.071 3.845 12.233 2.74 15.985-2.459a11.993 11.993 0 0 0 2.244-6.901h-10.76z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.183 11.382c0-.28-.068-.491-.188-.65-.137-.157-.36-.298-.685-.456-.806-.334-1.388-.667-1.748-1-.36-.335-.548-.826-.548-1.494 0-.597.188-1.07.582-1.457.394-.386.908-.597 1.56-.667V4.55h.805v1.124c.617.088 1.096.351 1.456.773.36.421.531.966.514 1.633l-.017.018h-1.696c0-.387-.069-.668-.223-.843a.648.648 0 0 0-.565-.281c-.24 0-.429.07-.531.228-.12.158-.172.351-.172.58 0 .245.069.438.189.579.12.158.36.299.702.457.788.35 1.37.684 1.748 1.036.377.35.565.843.565 1.475 0 .614-.188 1.089-.565 1.475-.377.369-.874.597-1.508.65v1.053h-.805v-1.053c-.668-.07-1.217-.299-1.645-.703-.428-.404-.651-1-.634-1.791l.017-.035h1.68c0 .439.085.737.273.93.189.194.429.282.72.282.24 0 .428-.07.565-.229.086-.105.154-.298.154-.527z",
    fill: "#1E2969"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomBudget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-budget.f7fa8ba0ec24e12a0d2d9596af555de7.svg";